
import {  Component,FormPageMixins,Mixins,appConst,PageResultModalMixins } from "@/lib";
import CreateLogisticsCost from"./create-logisticscost.vue";
import LogisticsCost from "@/store/modules/shipment/logisticscost/entity";
import LogisticsCostEntity from "@/store/modules/shipment/logisticscost/logisticscost";
import CardTitleView from "@/components/card-title/index.vue"
import { Row } from "view-design";
@Component({
    components:{CreateLogisticsCost,CardTitleView}
})
export default class RegistrationLogisticsCostView extends  Mixins(FormPageMixins, PageResultModalMixins) {
     model:LogisticsCost = new LogisticsCost();
     securityItem:any;//选项明细集合（弹框用）
async created() {

            Object.assign(this.config,{
            getAction: "shipment/logisticscost/get",
           //  labelWidth:220,
            pageTitleL:"app.FactoryCost.Registration",
            okAction:"shipment/logisticscost/create",
            isRedirectIndex:true

        })
       
  }
  get record(){
        return this.$store.state.shipment.logisticscost.editLogisticsCost;
    }
    securityColumn = [
        {
            title: this.L('app.LogisticsCost.SerialNumber'),
            slot: 'serialNumber',
            key: 'serialNumber',
            width: 80
          },
          {
            title: this.L('app.LogisticsCost.LogisticsName'),
            slot: 'logisticsName',
            key: 'logisticsName',
            minwidth: 150
          },
          {
                title: this.L("app.LogisticsCost.Amount"),
                key: "amount",
                width: 150,
                render: (h: any, params: any) => {
                return [h("span", this.$util.format.amount(params.row.amount))];
                },
          },
          {
            title: this.L('app.LogisticsCost.Currency'),
            slot: 'currency',
            key: 'currency',
            width: 80
          },
          {
            title: this.L('app.LogisticsCost.ExchangeRate'),
            slot: 'exchangeRate',
            key: 'exchangeRate',
            render: (h, {row}) => {
                if(row.exchangeRate!=0){
                    if(row.currency==='RMB'){
                        
                        return [h("span", 1)];
                    }
                    else{
                        if(row.ExchangeRate!=0){
                             return [h("span", row.exchangeRate)];
                        }
                        else{
                            return [h("span", row.exchangeRate)];
                        }
                    }
                    
                }
                else{
                    if(row.currency==='RMB'){
                        
                        return [h("span", 1)];
                    }
                    else{
                        if(row.exchangeRate!=0){
                             return [h("span", row.exchangeRate)];
                        }
                        else{
                            return [h("span", "NA")];
                        }
                        
                    }
                     
                }
                
                },
            width: 100
          },
          {
            title: this.L('app.LogisticsCost.InvoiceNumber'),
            slot: 'invoiceNumber',
            key: 'invoiceNumber',
            width: 150
          },
          this.$util.render.dateColumn(
            "app.LogisticsCost.PaymentDate",
            "paymentDate",
            { width: 120 }
          ),
          {
            title: this.L('app.LogisticsCost.Remark'),
            slot: 'remark',
            key: 'remark'
          },
          {
            title: this.L('Action.Actions'),
            slot: 'action',
            key: 'action',
            width: 120
          }
    ];
       addSecurityCheckItem(){
            this.securityItem = new LogisticsCostEntity;
            this.$store.commit("shipment/logisticscost/setSecurityItem", {securityItem: this.securityItem});
        this.open("factory-dlg");
    }
    async getSecurityCheckItem(Item){
        if(Item._index == undefined)
        {
                if(Item.currency==='RMB'){
                    Item.exchangeRate=this.model.rmbExchangeRate
                }
                else if(Item.currency===undefined||Item.currency===""){
                    Item.exchangeRate=0
                }
                else{
                    if(this.model.exchangeRate==0&&this.model.realExchangeRate==0){
                        Item.exchangeRate=0
                    }
                    else if(this.model.realExchangeRate===0)
                    {
                        Item.exchangeRate=this.model.exchangeRate
                    }
                    else{
                        Item.exchangeRate=this.model.realExchangeRate
                    }
                    
                }
            
            this.model.recordDto.push(Item);
            
        }
        else
        {
            if(Item.currency==='RMB'){
                Item.exchangeRate=this.model.rmbExchangeRate;
            }
            else if(Item.currency===undefined||Item.currency===""){
                    Item.exchangeRate=0
                }
            else{
                if(this.model.exchangeRate==0){
                        Item.exchangeRate=0
                    }
                    else{
                        Item.exchangeRate=this.model.exchangeRate
                    }
            }
            Object.assign(this.model.recordDto[Item._index], Item)
        }

        this.model.recordDto;
    }
    async securityDelete(index) {
        this.model.recordDto.splice(index,1);
    }
     async securityEdit (row, index) {
        this.securityItem = row;
        this.$store.commit("shipment/logisticscost/setSecurityItem", {securityItem: this.securityItem});

        this.open("factory-dlg");
    }
    get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
    handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.FactoryCost.SubTotal');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0||index===6 ||index===4||index===5||index===7||index===8 ) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        if (index === 3) {
            sums[key] = {
                key,
                value: 'RMB'
            };
            return;
        }
        let total=0;
        let totalNa=null;
        data.forEach((column, index) => {
            if(column.currency==='USD'){
                total+= column.amount * column.exchangeRate
            }
            else{
                total+=column.amount;
            }
            if(column.exchangeRate===0&&column.currency==='USD'){
                totalNa='NA'
            }
        });
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            // const v = values.reduce((prev, curr) => {
            //     const value = Number(curr);
            //     if (!isNaN(value)) {
            //         return prev + curr;
            //     } else {
            //         return prev;
            //     }
            // }, 0);
            if(total>0&&totalNa!='NA'){
                
                sums[key] = {
                key,
                value: this.$util.format.amount(total)
            };

            }
            else{
                sums[key] = {
                key,
                value:"NA"
            };
            }
            
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }
  
}

